import { ContentTableItem } from "src/components/ContentTable/ContentTable";

export function mapPeopleToContentTableItems(
	people: Person[]
): ContentTableItem[] {
	return people.map((person) => ({
		id: person.id,
		name: person.name,
		isActive: !person.archived,
		lastUpdated: person.updatedAt,
		data: {
			uuid: person.id,
			email: person.email,
			role: person.role,
			store: person.store?.name ?? "—",
			archived: person.archived
		}
	}));
}
